module.exports = __webpack_public_path__ + "img/screen_th.17517d66.jpg";